<template>
  <div class="page-container md-layout-column">

    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-toolbar class="toolbar-title" md-elevation="0">
        <span class="md-title">Filtros</span>
      </md-toolbar>

      <md-list>
        <md-list-item>
          <div class="md-list-item-text">
            <md-button class="md-raised md-primary" @click="onApplyFilter()">Aplicar</md-button>
          </div>
        </md-list-item>

        <md-list-item>
          <div class="md-list-item-text">
            <md-subheader>Rango de minutos</md-subheader>

            <label class="pe-radio" v-for="(minute) in this.minutes" :key="minute">
              <input type="radio" v-model="selectedMinutes" :value="minute" name="radio">
              <span class="checkmark"></span>
              <span class="pe-radio-text">{{ minute }}</span>
            </label>
          </div>
        </md-list-item>

        <md-list-item>
          <div class="md-layout-item">
            <md-subheader for="selectedDucto">Ducto</md-subheader>
          </div>
        </md-list-item>
        <li class="custom-select">
          <multiselect v-model="selectedDucto" :options="ductos" :max-height=200 placeholder="Seleccione el ducto"
            label="section_name" track-by="id_section" selectLabel="Seleccionar" deselectLabel="Deseleccionar">
          </multiselect>
        </li>

        <md-list-item>
          <div class="md-layout-item">
            <md-subheader for="selectedStations">Estaciones</md-subheader>
          </div>
        </md-list-item>
        <li class="custom-select">
          <multiselect v-model="selectedStations" :options="filteredStations" :max-height=200 
            :multiple="true"
            :close-on-select="false" 
            :clear-on-select="false" 
            selectLabel="◯" 
            selectedLabel="✔" 
            deselectLabel="✖" 
            placeholder="Seleccione las estaciones" label="site_name" track-by="id_site" 
            selectGroupLabel="Seleccionar todo" deselectGroupLabel="Deseleccionar todo"
            group-values="sites" group-label="section_name" :group-select="true">
            <template slot="selection" slot-scope="{values, search, isOpen}">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                activa(s)</span>
            </template>
            <template slot="noOptions">Lista vacía</template>
            <template slot="noResult">No se encontraron resultados</template>
          </multiselect>
        </li>

      </md-list>
    </md-drawer>

    <md-content>
      <div class="chart-container" v-if="this.isChartVisible">
        <apexchart height="400" type="line" :options="chartOptions" :series="series"></apexchart>
      </div>

      <md-empty-state v-if="!this.isChartVisible" md-rounded md-icon="settings" md-label="Nada que graficar"
        md-description="Seleccione las opciones de graficas desde el boton de agregar filtros">
      </md-empty-state>

      <md-speed-dial class="md-bottom-right" md-direction="bottom" md-event="click"
        @click.native="showSidepanel = true">
        <md-speed-dial-target class="md-primary">
          <md-icon>add</md-icon>
        </md-speed-dial-target>
      </md-speed-dial>

    </md-content>
  </div>
</template>

<script>
export default {
  data: () => ({
    showSidepanel: true,
    ductos: [],
    selectedStations: null,
    selectedDucto: null,
    minutes: [10, 20, 30],
    selectedMinutes: 10,
    filterDuctos: [],
    filterMinutes: 0,
    selectedDate: null,
    isChartVisible: false,
    isDestroyed: false,
    series: [{
      name: '',
      data: [],
    }],
    chartOptions: {
      noData: {
        text: 'Cargando...'
      },
      chart: {
        type: 'line',
        width: '100%',
        height: '80%',
        responsive: true,
        maintainAspectRatio: false,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: 'zoom'
        },
        animations: {
          enabled: true,
          easing: 'linear',
          dynamicAnimation: {
            speed: 1000
          }
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 1.9,
      },
      title: {
        text: '',
        align: 'left'
      },
      markers: {
        size: 0,
      },
      yaxis: {
        forceNiceScale: true,
        tickAmount: 6,
        min: 0,
        max: 100,
        logarithmic: false,
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'category',
        tickAmount: 4,
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          rotate: 0,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
        },
        axisTicks: {
          show: true,
        },
      },
    },
  }),
  computed: {
    filteredStations() {
      if (!this.selectedDucto) {
        return this.ductos;
      }
      return this.ductos.filter(q => q.id_section === this.selectedDucto.id_section);
    }
  },
  mounted() {
    this.$store
      .dispatch('LOAD_OPS')
      .then((resp) => {
        this.ductos = resp;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.isDestroyed = true;
  },
  methods: {
    onApplyFilter() {
      this.filterDuctos = this.selectedStations;
      this.filterMinutes = this.selectedMinutes;
      this.filterDuctos.forEach(q => {
        q.report_data_id = 0;
      });

      this.series = [];

      if (this.filterDuctos.length > 0) {
        this.showSidepanel = false;
        this.isChartVisible = true;
        this.loadDecimationSites();
      }
    },
    loadDecimationSites() {
      clearInterval(this.timer);
      const sites = {
        sites: this.filterDuctos
      };
      const sites_json = JSON.stringify(sites);
      if (this.isDestroyed) {
        return;
      }
      this.$store
        .dispatch('LOAD_DECIMATION_SITES', {
          minutes: this.filterMinutes,
          sites_json: btoa(sites_json)
        })
        .then((resp) => {
          if (resp.data === null || resp.data.length === 0) {
            this.timer = setInterval(this.loadDecimationSites, 30000);
            return;
          }
          if (this.addChartData(resp.data)) {
            this.timer = setInterval(this.loadDecimationSites, 500);
          } else {
            this.timer = setInterval(this.loadDecimationSites, 10000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addChartData(reportData) {
      const newChartData = reportData.data;
      const limit = reportData.limit[0].lower_limit_timestamp;

      if (newChartData.length == 0) {
        return false;
      }

      var fixedChartData = [];
      this.filterDuctos.forEach(x => {
        const ducto = this.ductos.find(d => d.id_section === x.id_section);
        const site = ducto.sites.find(s => s.id_site === x.id_site);

        const chartName = ducto.id_section + ' - ' + site.site_name;
        const chartData = newChartData.filter(f => f.id_site === x.id_site && f.id_section === x.id_section);

        var siteChart = {
          name: chartName,
          data: [],
        }

        if (chartData && chartData.length > 0) {
          var last = chartData[chartData.length - 1];
          x.report_data_id = last.report_data_id;
          siteChart.data = chartData.map(q => ({ x: q.report_date, y: 0, real_value: q.data, timestamp: q.timestamp }));
        }

        fixedChartData.push(siteChart);
      });

      this.series = this.normalizeData(this.series.filter(q => q.name !== ''), fixedChartData, limit);

      return true;
    },
    normalizeData(sourceSeries, chartData, limit) {
      // append new data
      chartData.forEach(x => {
        var target = sourceSeries.filter(q => q.name == x.name);
        if (target && target.length > 0) {
          target[0].data = target[0].data.concat(x.data);
        } else {
          sourceSeries.push(x);
        }
      });

      sourceSeries.forEach(x => {
        x.data = x.data.filter(q => q.timestamp >= limit);

        if (x.data.length > 0) {
          const max = Math.max.apply(Math, x.data.map(q => q.real_value));
          const min = Math.min.apply(Math, x.data.map(q => q.real_value));
          const limit = max - min;
          x.data.forEach(q => {
            const y = (((q.real_value) - min) / limit) * 100;
            q.y = parseFloat(y.toFixed(4));
          });
        }
      });

      return sourceSeries;
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-select {
  padding: 4px 16px;
}

.md-drawer {
  width: 320px;
  max-width: calc(100vw - 125px);
  z-index: 10;
}

.toolbar-title {
  min-height: 44px;
}

.md-radio {
  margin: 0;
}

.md-datepicker {
  margin: 0;
}

.md-list {
  margin: 0;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: var(--radio-button-checked);
}

input:focus+.slider {
  box-shadow: 0 0 1px var(--radio-button-checked);
}

input:checked+.slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider-text {
  margin: 0 8px;
  font-size: 12px;
  position: absolute;
  cursor: pointer;
}

/* The container */
.pe-radio {
  display: block;
  position: relative;
  padding-left: 17.5px;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.pe-radio-text {
  font-size: 14px;
  margin: 0 8px;
  display: block;
}

/* Hide the browser's default radio button */
.pe-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.pe-radio:hover input~.checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.pe-radio input:checked~.checkmark {
  background-color: var(--radio-button-checked);
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.pe-radio input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.pe-radio .checkmark:after {
  top: 4.5px;
  left: 4.5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: white;
}
</style>



// WEBPACK FOOTER //
// PresionNormal.vue?67f7a80b